$(document).ready(function() {
    // Get the checkboxes and submit button
    let body = document.body;
    let checkboxes = $('input[data-bi-policy]');
    const submitButtonWrapper = document.querySelector('.wc-gzd-order-submit');
    if(!submitButtonWrapper) return;

    // Attach a change event handler to all checkboxes with data-bi-policy attribute
    checkboxes.on('change', function() {
        // Check if all checkboxes are checked
        let allChecked = checkboxes.filter(':checked').length === checkboxes.length;

        // Toggle the disabled state of the submit button based on whether all checkboxes are checked
        if(allChecked) {
            body.classList.add('show-order-submit-button');
        } else {
            body.classList.remove('show-order-submit-button');
        }
    });
});